/* unplugin-vue-components disabled */
import $prompts from 'stores/prompts'
export default {
  emits: ['close', 'create', 'close-modal', 'select-prompt'],
  data() {
    return {
      search: '',
    }
  },
  computed: {
    c_prompts(){
      return $prompts.prompts.filter(
        item => item.title?.toLowerCase().includes(this.search.toLowerCase()) || item.prompt.toLowerCase().includes(this.search.toLowerCase())
      )
        .sort((a, b) => new Date(b.last_used) - new Date(a.last_used))
    },
    
    empty(){
      return !this.c_prompts.length
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close(){
      this.$refs.modal.close()
    },
    closeAll(){
      // it means that we are closing all prompt modals
      this.close()
      this.$emit('close-modal')
    },
    deletePrompt(id){
      $prompts.deletePrompt(id)
    },
    editPrompt(prompt){
      this.close()
      this.$emit('create', prompt)
    },
    onCreate(){
      this.close()
      this.$emit('create')
    },
    selectPrompt(data){
      this.$emit('select-prompt', data.prompt)
      $prompts.updatePrompt(data.id, {last_used: new Date().toISOString()})
      this.close()
    },
    clearSearch(){
      this.$refs.search.clearSearch()
    },
    sharePrompt(prompt_id){
      $utils.copyText(`${window.location.origin}/share-prompt?id=${prompt_id}`) 
      $utils.toasts.success('Prompt link copied to clipboard', 5000) 
    }
  },
}
